import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const CHECK_PLAN_REACTIVATION_ELIGIBILITY_KEY = 'checkPlanReactivationEligibility';

export const useCheckPlanReactivationEligibility = (planIds: string[]) => {
  const planIdsParam = planIds.join(',');

  const { data, isLoading, refetch } = useQuery(
    [CHECK_PLAN_REACTIVATION_ELIGIBILITY_KEY, planIdsParam],
    () => api.get(API_URL.PLANS_REACTIVATION_ELIGIBILITY, {
      params: { plan_ids: planIdsParam },
    }),
    {
      enabled: planIds.length > 0,
      retry: 0,
    }
  );

  return {
    isPlanEligibleForReactivation: data?.data,
    isLoading,
    refetch,
  };
};
